import { BaseApiService } from '../base/BaseApiService';

/** 0=domingo .. 6=sábado — mesma convenção do DateTime.DayOfWeek do backend. */
export enum EDayOfWeek {
  Domingo = 0,
  Segunda = 1,
  Terca = 2,
  Quarta = 3,
  Quinta = 4,
  Sexta = 5,
  Sabado = 6,
}

export const DAY_OF_WEEK_LABELS: Record<EDayOfWeek, string> = {
  [EDayOfWeek.Domingo]: 'Domingo',
  [EDayOfWeek.Segunda]: 'Segunda',
  [EDayOfWeek.Terca]: 'Terça',
  [EDayOfWeek.Quarta]: 'Quarta',
  [EDayOfWeek.Quinta]: 'Quinta',
  [EDayOfWeek.Sexta]: 'Sexta',
  [EDayOfWeek.Sabado]: 'Sábado',
};

/**
 * O backend serializa System.DayOfWeek como string (JsonStringEnumConverter), não como
 * número — apesar do POST aceitar o número do EDayOfWeek de volta. As respostas (GET/POST)
 * vêm com esse formato, não com EDayOfWeek numérico.
 */
export type ApiDayOfWeek = 'sunday' | 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday';

export const API_DAY_OF_WEEK_LABELS: Record<ApiDayOfWeek, string> = {
  sunday: 'Domingo',
  monday: 'Segunda',
  tuesday: 'Terça',
  wednesday: 'Quarta',
  thursday: 'Quinta',
  friday: 'Sexta',
  saturday: 'Sábado',
};

export interface CqvScheduleResponseDto {
  id: string;
  userId: string;
  userNome: string;
  dayOfWeek: ApiDayOfWeek;
  startTime: string; // "HH:mm:ss"
  endTime: string;
  coversGcm: boolean;
  isActive: boolean;
}

export interface CreateCqvScheduleRequest {
  userId: string;
  dayOfWeek: EDayOfWeek;
  startTime: string; // "HH:mm"
  endTime: string;
  coversGcm: boolean;
}

/** Cria a mesma escala (usuário/horário) em vários dias de uma vez. */
export interface CreateCqvScheduleBulkRequest {
  userId: string;
  daysOfWeek: EDayOfWeek[];
  startTime: string; // "HH:mm"
  endTime: string;
  coversGcm: boolean;
}

export interface UpdateCqvScheduleRequest {
  startTime: string; // "HH:mm"
  endTime: string;
  coversGcm: boolean;
}

/** Escala de quem faz CQV por período — specs/solicitacao-cqv-automatica-sla (AC#10). */
export class CqvScheduleService extends BaseApiService {
  async list(): Promise<CqvScheduleResponseDto[]> {
    const response = await this.api.get<CqvScheduleResponseDto[]>('/v1/cqv-schedule');
    return response.data;
  }

  async create(request: CreateCqvScheduleRequest): Promise<CqvScheduleResponseDto> {
    const response = await this.api.post<CqvScheduleResponseDto>('/v1/cqv-schedule', request);
    return response.data;
  }

  async createBulk(request: CreateCqvScheduleBulkRequest): Promise<CqvScheduleResponseDto[]> {
    const response = await this.api.post<CqvScheduleResponseDto[]>('/v1/cqv-schedule/bulk', request);
    return response.data;
  }

  async update(id: string, request: UpdateCqvScheduleRequest): Promise<CqvScheduleResponseDto> {
    const response = await this.api.put<CqvScheduleResponseDto>(`/v1/cqv-schedule/${id}`, request);
    return response.data;
  }

  async deactivate(id: string): Promise<void> {
    await this.api.delete(`/v1/cqv-schedule/${id}`);
  }
}

export const cqvScheduleService = new CqvScheduleService();
